import styled from "styled-components";

export const AppContainer = styled.div`
  padding: 0;
  margin: 0;
`;
